import React from 'react';
import styled from 'styled-components';
import UnrevokedButton from './UnrevokedButton';
import DeleteMultiRevokedTicket from './DeleteMultiRevokedTicket';
import useGetSummaryRevokedCash from 'features/ticketList/services/hooks/useGetSummaryRevokedCash';
import Text from 'components/Text';
import Box from 'components/Box';
import { formatCurrency } from 'utils/formatCurrency';

interface ArchivedActionProps {
  selectedRowKeys: string[];
  onSuccess: () => void;
}
const ArchivedAction = ({ selectedRowKeys, onSuccess }: ArchivedActionProps) => {
  const { summaryRevokedCash } = useGetSummaryRevokedCash();

  return (
    <Container>
      <UnrevokedButton selectedRowKeys={selectedRowKeys} onSuccess={onSuccess} />
      <DeleteMultiRevokedTicket selectedRowKeys={selectedRowKeys} onSuccess={onSuccess} />
      <Box display='flex' gap='2' alignItems='center'>
        <Text
          variant='H7'
          color='v2_other_3'
          style={{ fontFamily: 'Poppins', fontWeight: 500, lineHeight: 1 }}
        >
          Total Revoked Cash:
        </Text>
        <Text
          variant='H5'
          style={{ fontFamily: 'Poppins', fontWeight: 500, lineHeight: 1,  }}
          color='v2_other_3'
        >
          {summaryRevokedCash?.cashRevokedAmount
            ? formatCurrency(summaryRevokedCash.cashRevokedAmount.toFixed(2))
            : '$0.00'}
        </Text>
      </Box>
    </Container>
  );
};

export default ArchivedAction;

const Container = styled.div`
  display: flex;
  align-items: center;

  gap: 16px;
  .CONTENT_2 {
    font-size: 22px;
    line-height: 1;
  }
`;
